var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-material-edit","title":_vm.projectMaterial.material.name,"toptitle":"Material bearbeiten","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-material-form',{attrs:{"projectMaterial":_vm.projectMaterial,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }